import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { map, Observable, Subject } from 'rxjs';
import { AuthService } from '@core/auth/auth.service';
import { IResponse, Response } from '@shared/models/response-with-token';
import { IProveedor } from 'app/modules/administracion/proveedores/models/proveedor';

@Injectable()
export class EnviarEmailModalService {
    constructor(private http: HttpClient, private _authService: AuthService) { }

    getProveedores(option?) {
        let f = '?sort=RazonSocial';
        f += !option ? '&filter[activo]=1' : '';
        let subject = new Subject<any>();
        this.http.get<Response[]>(`${environment.administracion.proveedores_token}${f}`)
            .subscribe((resp: any) => {
                this._authService.accessToken = resp.token;
                subject.next({
                    list: resp.result
                })
            });
        return subject.asObservable();
    }

    getClientes(option?) {
        let f = '?sort=RazonSocial';
        f += !option ? '&filter[activo]=1' : '';
        let subject = new Subject<any>();
        this.http.get<Response[]>(`${environment.administracion.view_clientes}${f}`)
            .subscribe((resp: any) => {
                this._authService.accessToken = resp.token;
                subject.next({
                    list: resp.result
                })
            });
        return subject.asObservable();
    }

    getEmpleados() {
        let subject = new Subject<any>();
        this.http.get<Response[]>(`${environment.rrhh.empleados.rh_empleados}`)
            .subscribe((resp: any) => {
                this._authService.accessToken = resp.token;
                subject.next({
                    list: resp.result
                });
            });
        return subject.asObservable();
    }

    getEmpresaMails(tipo?: number): Observable<any[]> {
        let url = `${environment.seguridad.empresas.view_emp_empresa_mails}?pagination=false`;
        if (tipo) {
            url += `&filter[tipo]=${tipo}`;
        }
        return this.http.get<any>(url).pipe(
            map((resp: any) => {
                if (resp && resp.token) {
                    this._authService.accessToken = resp.token;
                }
                return resp?.result || [];
            })
        );
    }

    enviarEmail(payload, _endpointService: string): Observable<any> {
        return this.http.post<any>(_endpointService, payload);
    }
}

